import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

import { ColorVariant } from "@/components/canvas-editor/components/Container";
import { ColorSelect } from "@/components/ColorSelect";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { createTag } from "@/lib/api";

export function CreateTagDialog({
  children,
  open,
  onOpenChange,
  defaultName,
}: {
  children: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  defaultName?: string;
}) {
  const [color, setColor] = useState<ColorVariant>("amber");
  const [name, setName] = useState(defaultName || "");
  const createTagMutation = useMutation({
    mutationFn: async () => {
      await createTag({
        color,
        display_name: name,
      });
    },
  });

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Create a tag</AlertDialogTitle>
          <AlertDialogDescription>
            Create a tag to help you organize your feeds.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <Separator />
        <div className="flex flex-col gap-6 py-4">
          <div className="flex flex-col gap-2">
            <Label htmlFor="name">Name</Label>
            <Input
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Favorite"
            />
          </div>
          <ColorSelect
            defaultValue={color}
            label="Tag Color"
            onChange={setColor}
          />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={() => createTagMutation.mutate()}>
            Add
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
